import React from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { isAnnouncement } from '../utils/newsUtils';

const BADGE_STYLES = {
    new: { backgroundColor: '#D92D20', color: '#FFFFFF' },
    upcoming: { backgroundColor: '#1D4ED8', color: '#FFFFFF' },
    announcement: { backgroundColor: '#FFFFFF', color: '#B54708', border: '1px solid #FEC84B' }
};

const Badge = ({ type, label }) => (
    <span className="text-xs font-bold border-round px-2 py-1" style={{ letterSpacing: '0.04em', textTransform: 'uppercase', lineHeight: 1.2, ...BADGE_STYLES[type] }}>
        {label}
    </span>
);

const LmsNewsBadges = ({ news, className = '', includeAnnouncement = true }) => {
    const { th } = useLanguage();
    const badges = [];
    if (news?.isNew) badges.push({ type: 'new', label: th('lmsNews.badgeNew') });
    if (news?.isUpcoming) badges.push({ type: 'upcoming', label: th('lmsNews.badgeUpcoming') });
    if (includeAnnouncement && isAnnouncement(news)) badges.push({ type: 'announcement', label: th('lmsNews.announcementTag') });

    if (badges.length === 0) return null;

    return (
        <div className={`flex align-items-center gap-2 flex-wrap ${className}`.trim()}>
            {badges.map((badge) => (
                <Badge key={badge.type} type={badge.type} label={badge.label} />
            ))}
        </div>
    );
};

export default LmsNewsBadges;
